import { Component, HostBinding, Input } from '@angular/core';

type CoreUISkeletonShape = 'rect' | 'pill' | 'circle';

@Component({
  selector: 'core-ui-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
  standalone: false
})
export class CoreUISkeletonComponent {
  @Input() width: string | number = '100%';
  @Input() height: string | number = '16px';
  @Input() radius: string | number | null = null;
  @Input() shape: CoreUISkeletonShape = 'rect';

  @HostBinding('style.width')
  get widthValue(): string {
    return this.normalizeSize(this.width);
  }

  get heightValue(): string {
    return this.normalizeSize(this.height);
  }

  get radiusValue(): string | null {
    if (this.radius !== null) return this.normalizeSize(this.radius);
    if (this.shape === 'circle' || this.shape === 'pill') return '999px';

    return '8px';
  }

  private normalizeSize(value: string | number): string {
    return typeof value === 'number' ? `${value}px` : value;
  }
}
